"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteTitle = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHelmet = require("react-helmet");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RouteTitle = function RouteTitle(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, "0xpay | ".concat(title !== null && title !== void 0 ? title : 'Page Not Found'))));
};
exports.RouteTitle = RouteTitle;